import React, { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import { useAuth } from '../context/AuthContext';
import TransliteratedInput from '../components/TransliteratedInput';

export default function EditProfile() {
  const { user } = useAuth();
  const [firstName, setFirstName] = useState(user?.firstName || '');
  const [lastName, setLastName] = useState(user?.lastName || '');
  const [email, setEmail] = useState(user?.email || '');
  const [saved, setSaved] = useState(false);

  const handleSave = async () => {
    try {
      // Call backend to update profile
      // const response = await fetch('/api/auth/profile', {
      //   method: 'PUT',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ firstName, lastName, email })
      // });
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (error) {
      console.error('Profile update failed:', error);
    }
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1, color: '#7f4b2d' }}>
        Edit Profile
      </Typography>
      <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
        Update your personal information below.
      </Typography>

      {saved && <Alert severity="success" sx={{ mb: 3 }}>Profile updated successfully!</Alert>}

      <Card sx={{ maxWidth: 600, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
        <CardContent sx={{ display: 'grid', gap: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Avatar sx={{ width: 80, height: 80, bgcolor: '#7f4b2d' }}>
              {user?.firstName?.[0]}{user?.lastName?.[0]}
            </Avatar>
            <Box>
              <Typography variant="caption" sx={{ color: '#999' }}>Profile Photo</Typography>
              <Typography variant="body2">{user?.firstName} {user?.lastName}</Typography>
            </Box>
          </Box>
          <TransliteratedInput
            label="First Name"
            value={firstName}
            onChange={setFirstName}
            onSuggestionSelect={setFirstName}
            multiline
            minRows={1}
            inputSx={{
              '& .MuiOutlinedInput-root': { minHeight: 44 },
              '& .MuiInputBase-input': { lineHeight: '1.5', paddingTop: '10px', paddingBottom: '10px' }
            }}
            placeholder="Type name in English (e.g., rama, siva)"
          />
          <TransliteratedInput
            label="Last Name"
            value={lastName}
            onChange={setLastName}
            onSuggestionSelect={setLastName}
            multiline
            minRows={1}
            inputSx={{
              '& .MuiOutlinedInput-root': { minHeight: 44 },
              '& .MuiInputBase-input': { lineHeight: '1.5', paddingTop: '10px', paddingBottom: '10px' }
            }}
            placeholder="Type name in English (e.g., rama, siva)"
          />
          <TextField
            label="Email"
            fullWidth
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            variant="outlined"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
          />

          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button variant="contained" onClick={handleSave} sx={{ backgroundColor: '#7f4b2d', px: 4 }}>
              Save Changes
            </Button>
            <Button variant="outlined">Cancel</Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
